import { date } from './api';

export type StudyWorkItem = {
  id: string; title: string; sessionId?: string | null; status?: string;
  submissionState?: 'in_progress' | 'submitted' | 'revising';
  updatedAt?: string | null; feedbackAvailable?: boolean;
};

export function StudyWorkRow({item, disabled, onOpen}: {item: StudyWorkItem; disabled: boolean; onOpen: (id:string)=>Promise<void>}) {
  const status = item.submissionState === 'submitted' ? 'Submitted' : item.submissionState === 'revising' ? 'Changes since submission' : !item.sessionId && (!item.status || item.status === 'not-started') ? 'Not started' : 'In progress';
  return <article className="study-work-row" aria-label={item.title}>
    <div><h3>{item.title}</h3><p className="study-work-meta"><span className="status-pill">{status}</span>{item.updatedAt && <span>Updated {date(item.updatedAt)}</span>}{item.feedbackAvailable && <span>Feedback available</span>}</p></div>
    <button disabled={disabled} onClick={()=>void onOpen(item.id)} aria-label={`View assignment: ${item.title}`}>View assignment</button>
  </article>;
}
